export const GOOGLE_IDENTITY_SCRIPT_ID = "google-identity-services";

const GOOGLE_IDENTITY_SCRIPT_SRC = "https://accounts.google.com/gsi/client";
const GOOGLE_LOAD_ERROR_MESSAGE = "Nie udało się załadować logowania Google.";
const GOOGLE_UNAVAILABLE_ERROR_MESSAGE = "Google Identity Services is unavailable.";

let googleIdentityScriptPromise;

function isGoogleIdentityReady(win = window) {
  return Boolean(win.google && win.google.accounts && win.google.accounts.id);
}

export function resetGoogleIdentityForTests() {
  googleIdentityScriptPromise = null;
}

export function loadGoogleIdentityScript(doc = document, win = window, language = "pl") {
  if (isGoogleIdentityReady(win)) {
    return Promise.resolve();
  }

  if (googleIdentityScriptPromise) {
    return googleIdentityScriptPromise;
  }

  googleIdentityScriptPromise = new Promise((resolve, reject) => {
    const resolveWhenReady = () => {
      if (isGoogleIdentityReady(win)) {
        resolve();
        return true;
      }

      return false;
    };

    const rejectAsUnavailable = () => {
      googleIdentityScriptPromise = null;
      reject(new Error(GOOGLE_UNAVAILABLE_ERROR_MESSAGE));
    };

    const rejectAsLoadFailure = (scriptToRemove) => {
      if (scriptToRemove && scriptToRemove.parentNode) {
        scriptToRemove.parentNode.removeChild(scriptToRemove);
      }

      googleIdentityScriptPromise = null;
      reject(new Error(GOOGLE_LOAD_ERROR_MESSAGE));
    };

    if (resolveWhenReady()) {
      return;
    }

    const existingScript = doc.getElementById(GOOGLE_IDENTITY_SCRIPT_ID);

    if (existingScript) {
      existingScript.addEventListener("load", () => {
        if (!resolveWhenReady()) {
          rejectAsUnavailable();
        }
      }, { once: true });
      existingScript.addEventListener("error", () => rejectAsLoadFailure(existingScript), { once: true });
      return;
    }

    const script = doc.createElement("script");
    script.id = GOOGLE_IDENTITY_SCRIPT_ID;
    script.src = `${GOOGLE_IDENTITY_SCRIPT_SRC}?hl=${language === "en" ? "en" : "pl"}`;
    script.async = true;
    script.defer = true;
    script.addEventListener("load", () => {
      if (!resolveWhenReady()) {
        rejectAsUnavailable();
      }
    }, { once: true });
    script.addEventListener("error", () => rejectAsLoadFailure(script), { once: true });
    doc.head.appendChild(script);
  });

  return googleIdentityScriptPromise;
}

export function initializeGoogleIdentityButton({
  clientId,
  language = "pl",
  buttonElement,
  onCredential,
  onClick,
}) {
  const googleIdentity = window.google && window.google.accounts && window.google.accounts.id;

  if (!googleIdentity) {
    throw new Error(GOOGLE_UNAVAILABLE_ERROR_MESSAGE);
  }

  const renderTarget = buttonElement;
  renderTarget.innerHTML = "";

  googleIdentity.initialize({
    client_id: clientId,
    callback: onCredential,
  });

  googleIdentity.renderButton(renderTarget, {
    theme: "outline",
    size: "large",
    width: renderTarget.offsetWidth || 320,
    text: "signin_with",
    locale: language,
    click_listener: onClick,
  });
}
